/**

@module

## Anatomy

```jsx
import {
  ResizableHandle,
  ResizableRoot,
} from 'prosekit/react/resizable'

<ResizableRoot>
  <img src="..." />
  <ResizableHandle>...</ResizableHandle>
</ResizableRoot>
```
*/

'use client'

export * from './index.gen.ts'
